// src/hooks/useActiveDownloads.js
// Set of board pack file downloads in flight ("<jobId>-<type>"), shared by every
// component so a closed-and-reopened dialog still knows what is downloading.
import { useSyncExternalStore } from "react";
import { getActiveDownloads, subscribeDownloads } from "@/lib/reportJobs";

export const useActiveDownloads = () =>
  useSyncExternalStore(subscribeDownloads, getActiveDownloads, getActiveDownloads);
